import { Stack, Typography } from "@mui/material";
import type { MatchOption } from "./models";

export function MatchOptionLabel({ option }: { option: MatchOption }) {
	return (
		<Stack gap={0.25} sx={{ overflowWrap: "anywhere" }}>
			<Typography variant="body2">
				Rollshop: {option.rollshopName ?? "-"}
				{option.rollshopId != null && (
					<Typography component="span" variant="caption" color="text.secondary">
						{" "}
						(ID {option.rollshopId})
					</Typography>
				)}
			</Typography>
			<Typography variant="body2">
				MES: {option.mesName ?? "-"}
				{option.mesId != null && (
					<Typography component="span" variant="caption" color="text.secondary">
						{" "}
						(ID {option.mesId})
					</Typography>
				)}
			</Typography>
		</Stack>
	);
}
